import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomInputModule } from '../components/input/custom-input.module';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { CustomPipesModule } from '../pipes/custom-pipes.module';
import { InvoicesService } from './services/invoices.service';
import { InvoiceLinesService } from './services/invoice-lines.service';
import { CustomerService } from './services/customer.service';
import { InvoicesComponent } from './invoices.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoiceLineDetailComponent } from './invoice-detail/invoice-line/invoice-line-detail.component';
import { InvoiceLineFormComponent } from './invoice-detail/invoice-line/invoice-line-form.component';
import { InvoiceLineTableComponent } from './invoice-detail/invoice-line/invoice-line-table.component';
import { InvoiceLineInlineFormComponent } from './invoice-detail/invoice-line/invoice-line-inline-form.component';
import { InvoiceTotalsComponent } from './invoice-detail/invoice-totals.component';
import { InvoiceCustomerDetailComponent } from './invoice-detail/customer-detail/customer-detail.component';
import { InvoiceWeekTableComponent } from './invoice-week-selector/invoice-week-table/invoice-week-table.component';
import { InvoiceWeekSelectorComponent } from './invoice-week-selector/invoice-week-selector.component';
import { InvoiceSearchComponent } from './invoice-search/invoice-search.component';
import { InvoiceSettingsComponent } from './invoice-settings.component';
import { InvoiceCreateComponent } from './invoice-create/invoice-create.component';
import { CalendarModule } from 'primeng/primeng';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		InvoicesRoutingModule,
		CustomInputModule,
		CalendarModule,
		CustomPipesModule
	],
	exports: [
		InvoicesRoutingModule,
		InvoicesComponent,
		InvoiceDetailComponent,
		InvoiceLineDetailComponent,
		InvoiceLineFormComponent,
		InvoiceLineTableComponent,
		InvoiceLineInlineFormComponent,
		InvoiceTotalsComponent,
		InvoiceCustomerDetailComponent,
		InvoiceWeekTableComponent,
		InvoiceWeekSelectorComponent,
		InvoiceSearchComponent,
		InvoiceSettingsComponent,
		InvoiceCreateComponent
	],
	providers: [
		InvoicesService,
		InvoiceLinesService,
		CustomerService
	],
	declarations: [
		InvoicesComponent,
		InvoiceDetailComponent,
		InvoiceLineDetailComponent,
		InvoiceLineFormComponent,
		InvoiceLineTableComponent,
		InvoiceLineInlineFormComponent,
		InvoiceTotalsComponent,
		InvoiceCustomerDetailComponent,
		InvoiceWeekTableComponent,
		InvoiceWeekSelectorComponent,
		InvoiceSearchComponent,
		InvoiceSettingsComponent,
		InvoiceCreateComponent
	]
})

export class InvoicesModule
{
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoices.module.ts